import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import envelope from '../../../../assets/images/unsibscribe/envelope-mobile.png';
import envelopeTab from '../../../../assets/images/unsibscribe/envelope-tab.png';
import envelopeDesk from '../../../../assets/images/unsibscribe/envelope-desk.png';
import phone from '../../../../assets/images/unsibscribe/phone.png';

export const useStyles = makeStyles(({
  fontWeights, palette, breakpoints,
}: Theme) => ({
  root: {
    padding: '2rem 1rem',
    [breakpoints.up('lg')]: {
      paddingTop: '4rem',
    },
  },
  font: {
    margin: 0,
    color: palette.info.dark,
    fontSize: '0.75rem',
    lineHeight: '1.3',
    fontWeight: fontWeights.medium,
    textAlign: 'center',
    [breakpoints.up('md')]: {
      fontSize: '1rem',
      lineHeight: '1.5',
    },
    '& + p': {
      marginTop: '0.5rem',
    },
    '& a': {
      color: palette.info.dark,
      textDecoration: 'none',
    },
  },
  first: {
    [breakpoints.up('md')]: {
      width: '28.125rem',
      maxWidth: '100%',
    },
  },
  second: {
    [breakpoints.between(400, 768)]: {
      width: '32.5rem',
      maxWidth: '75%',
    },
    [breakpoints.up('md')]: {
      width: '32.5rem',
      maxWidth: '100%',
    },
  },
  fontItalic: {
    display: 'block',
    margin: '0.625rem auto',
    [breakpoints.up('md')]: {
      width: '22.5rem',
      maxWidth: '100%',
    },
  },
  envelope: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '28.75rem',
    padding: '2rem 1.5rem 1rem',
    background: `no-repeat url(${envelope}) center`,
    backgroundSize: 'cover',
    [breakpoints.between(400, 768)]: {
      height: '38rem',
      backgroundPositionY: 'bottom',
    },
    [breakpoints.up('md')]: {
      maxWidth: '44.5rem',
      height: '42.875rem',
      margin: '0 auto',
      padding: '4rem 4rem 2rem',
      background: `no-repeat url(${envelopeTab}) center`,
    },
    [breakpoints.up('lg')]: {
      maxWidth: '57.25rem',
      background: `no-repeat url(${envelopeDesk}) center`,
    },
  },
  logo: {
    margin: '0 0 1.25rem',
    '& img': {
      display: 'block',
      margin: '0 auto',
      width: '10.625rem',
      height: '2.125rem',
    },
  },
  subtitle: {
    color: palette.common.white,
    [breakpoints.up('md')]: {
      width: '28.125rem',
      maxWidth: '100%',
    },
  },
  grow: {
    flexGrow: 1,
  },
  footer: {
    padding: '1rem',
    background: palette.grey[200],
    [breakpoints.up('md')]: {
      width: 'calc(100% - 15.5rem)',
      marginTop: '1.25rem',
      padding: '2rem',
    },
    '& p': {
      [breakpoints.up('md')]: {
        textAlign: 'left',
      },
      '& + p': {
        marginTop: '0.75rem',
      },
    },
  },
  footerWrapper: {
    [breakpoints.up('md')]: {
      display: 'flex',
      maxWidth: '46.375rem',
      margin: '0 auto',
      padding: '0 1rem',
    },
    [breakpoints.up('lg')]: {
      maxWidth: '57.25rem',
    },
  },
  link: {
    textDecoration: 'underline',
  },
  disclaimer: {
    marginBottom: 0,
    fontSize: '0.75rem',
    lineHeight: '1.3',
    '& span': {
      display: 'block',
    },
  },
  phone: {
    width: '15.5rem',
    height: '16.875rem',
    margin: '0 auto',
    background: `no-repeat url(${phone}) top left`,
    backgroundSize: 'cover',
    [breakpoints.up('md')]: {
      height: 'auto',
    },
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1.25rem',
    padding: '0 1rem 2rem',
    [breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'center',
    },
    '&& button': {
      width: '100%',
      maxWidth: '20.5rem',
      [breakpoints.up('md')]: {
        width: 'fit-content',
      },
    },
  },
}));
